import i18next from 'i18next';

import commonEs from './common/es/index.json';
import commonEn from './common/en/index.json';
import commonPt from './common/pt/index.json';
import commonFr from './common/fr/index.json';

import ekEn from './ek/en/index.json';
import { LanguageNamespaces, LANGUAGE_NAMESPACE } from '@constants/language';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: LANGUAGE_NAMESPACE,
  fallbackNS: LanguageNamespaces.Common,
  ns: [LanguageNamespaces.Common, LANGUAGE_NAMESPACE],
  resources: {
    en: {
      common: commonEn,
      ek: ekEn,
    },
    es: {
      common: commonEs,
    },
    pt: {
      common: commonPt,
    },
    fr: {
      common: commonFr,
    },
  },
});

export default i18next;
